export default __webpack_public_path__ + "static/media/thedepthsink800x586.eb792ffd.jpg";